const DawaApiBaseUrl = 'https://dawa.aws.dk/';
export default {
  getAdresseringForKommunenummerVejkode (kommunekode, vejkode) {
    return fetch(
      `${DawaApiBaseUrl}vejstykker/${kommunekode}/${vejkode}`,
      {
        method: 'GET',
      }
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else if (response.status !== 404) {
          throw Error(response.statusText);
        }
      })
      .then(function (response) {
        return response;
      });
  },
  getAdressePunkterForKommunenummerVejkode (kommunekode, vejkode) {
    return fetch(
      `${DawaApiBaseUrl}adgangsadresser?vejkode=${vejkode}&kommunekode=${kommunekode}&srid=25832`,
      {
        method: 'GET',
      }
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error(response.statusText);
        }
      })
      .then(response => {
        return response;
      }, (error) => {
        throw new Error(error);
      });
  },
  getKommune (kommunekode) {
    return fetch(
      `${DawaApiBaseUrl}kommuner/${kommunekode}?srid=25832`,
      {
        method: 'GET',
      }
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error(response.statusText);
        }
      })
      .then(response => {
        return response;
      }, (error) => {
        throw new Error(error);
      });
  },
  getKommuner () {
    return fetch(
      `${DawaApiBaseUrl}kommuner/?srid=25832`,
      {
        method: 'GET',
      }
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error(response.statusText);
        }
      })
      .then(response => {
        return response;
      }, (error) => {
        throw new Error(error);
      });
  },
};
